import { render, staticRenderFns } from "./addVehicle.vue?vue&type=template&id=99a5f3ba&scoped=true"
import script from "./addVehicle.vue?vue&type=script&lang=js"
export * from "./addVehicle.vue?vue&type=script&lang=js"
import style0 from "./addVehicle.vue?vue&type=style&index=0&id=99a5f3ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a5f3ba",
  null
  
)

export default component.exports